<template>
	<svg :color="color" :width="width" :height="height">
    <use :href="getUrl"></use>
  </svg>
</template>

<script>
import myIcon from "@/assets/sprite.svg";
import halloween from "@/assets/spriteHalloween.svg";

export default {
	name: "SvgSprite",
	props: {
		halloween: {
			type: Boolean,
			default: false
		},
		color: {
			type: String,
			default: 'inherit'
		},
		width: {
			type: [ String, Number ],
			default: () => 20
		},
		height: {
			type: [ String, Number ],
			default: () => 20
		},
		iconId: String
	},
	computed: {
		getUrl() {
			const url = this.halloween ? halloween : myIcon;
			return `${ url }#${ this.iconId }`;
		}
	}
};
</script>
